module.exports = __webpack_public_path__ + "static/media/default_avatar.26a38e3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login/default_avatar.svg
// module id = 888
// module chunks = 0